import styled from 'styled-components';



export const Container = styled.div`
    display: flex;
    position: relative;
    width: 100%;
    overflow-y: auto;
    height: calc(80vh - 40px);
    padding-right: 30px;
    padding-bottom: 80px;

    @media (max-width: 768px) {
        width: 96vw;
        display: flex;
        overflow-x: hidden;
        padding: 16px;
        padding-bottom: 120px;
        flex-direction: column;
        height: auto;
        max-height: none;
    }
`;


export const LoadingWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 60%;
    margin-top:10%;
    font-size: 20px;
    font-weight: bold;
    color: #61cbc9;
    flex-direction: column;
    gap: 20px;
    top: 0;
    left: 0;
    background-color: rgba(255, 255, 255, 0.8); 
`;

export const LeftContainer = styled.div`
    flex: 0 0 30%; 

    @media (max-width: 768px) {
     flex: 0 0 12%; 
  }
    
`;

export const Title = styled.h1`
    font-size: 24px;
    font-weight: bold;
    color: #333;
    margin-bottom: 10px;
`;

export const ErrorWarp = styled.div`
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin:auto;
`;

export const ErrorImg = styled.img`
   width:150px;
`;
export const ErrorP = styled.h1`
    font-size: 18px;
    font-weight: bold;
    color: #61cbc9;
`;

export const Subtitle = styled.p`
    font-size: 16px;
    color: #555;
    margin-bottom: 20px;
`;

export const RightContainer = styled.div`
    flex: 0 0 70%; 
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: flex-start;  
    align-items: flex-start; 

    @media (max-width: 768px) {
        overflow-x: visible;
        flex: 100%;
        padding: 0;
        gap: 16px;
    }
`;

export const Pagination = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: 10%;
    width: 90%;

    @media (max-width: 768px) {
        position: static;
        margin-top: 20px;
        width: 100%;
        flex-wrap: wrap;
    }
`;

export const PaginationButton = styled.button`
    margin: 0 5px;
    padding: 10px;
    font-size: 16px;
    border: none;
    background-color: ${(props) => (props.active ? '#61CBC9' : 'transparent')};
    color: ${(props) => (props.active ? '#fff' : '#333')};
    border-radius: 4px;
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    transition: background-color 0.3s ease;

    &:hover {
        background-color: ${(props) => (!props.disabled && !props.active ? '#61CBC9' : '#61CBC9')};
    }

    @media (max-width: 768px) {
        width: 28px;
        height: 28px;
        font-size: 14px;
        padding: 8px;
    }
`;

export const CardWrapper = styled.div`
    width: 45%;

    ${({ $disabled }) => $disabled && `
        filter: grayscale(100%);
        opacity: 0.5;
        pointer-events: none;
    `}

    @media (max-width: 768px) {
        width: 100%;
    }
`;



